import { AxiosResponse } from 'axios';
import { appContextPost } from './httpCommon/appAxios.service';
import { SHIPPING_PAYMENT_ENDPOINTS } from '../constants/apiEndpoints';

export const makeShippingPaymentUsingCardOnFile = (accountId: number, payload: {} ): Promise<AxiosResponse<any>> => {
  return appContextPost(
    SHIPPING_PAYMENT_ENDPOINTS.SHIPPING_PAYMENT + accountId + SHIPPING_PAYMENT_ENDPOINTS.CARD_ON_FILE_PAYMENT,
    payload
  );
};

export const makeInstantShippingPayment = (
  accountId: number,
  paymentData: any,
): Promise<AxiosResponse<any>> => {
  return appContextPost(
    SHIPPING_PAYMENT_ENDPOINTS.SHIPPING_PAYMENT + accountId + SHIPPING_PAYMENT_ENDPOINTS.INSTANT_PAYMENT,
    paymentData
  );
};
